<div class="e-selector-dropdown-container" (mousedown)="preventDropdownClose($event)"
  (click)="preventDropdownClose($event)" (keydown)="preventDropdownClose($event)" (keyup)="preventDropdownClose($event)"
  (keypress)="preventDropdownClose($event)">
  <div class="e-left-col">
    @if (dialogTreeData && dialogTreeData.length > 0) {
    <div class="e-selector-content">
      <claims-search-bar [searchOptionsList]="dialogTreeData" [enableDropdownStyling]="true"
        (selectedSearchOptionEvent)="onSelectedNodeChange($event)" />
    </div>
    }
    <div id="e-tree">
      <tree-root [options]="treeOptions" #tree [nodes]="dialogTreeData" [focused]="true"
        (initialized)="onInitialized()">
        <ng-template #treeNodeTemplate let-node let-index="index">
          <label class="e-selector-tree-checkbox" [attr.data-node-id]="node.data.id">
            <input type="checkbox" [disabled]="node.data.isDisabled" [(ngModel)]="node.data.isSelected"
              (ngModelChange)="onSelectedNodeWithCheckBox(node)" />
            <span class="e-label-name" title="{{ node.data.name }}">{{ node.data.name }}</span>
            @if (isProductTree && node?.data?.children?.length > 0) {
            <claims-context-menu [node]="node" (menuItemClicked)="onProductMenuClick($event, node.data.id)">
            </claims-context-menu>
            }
          </label>
        </ng-template>
      </tree-root>
    </div>
  </div>
</div>